export const TEST_ID = 'editServiceRecordPanel';

export const FOOTER_TEST_ID = 'editServiceFooter';

export const FOOTER_CANCEL_BUTTON_TEST_ID = 'editServiceFooterCancelButton';

export const FOOTER_SAVE_BUTTON_TEST_ID = 'editServiceFooterSaveButton';
